export const UPDATE_USER = "UPDATE_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const SET_ISLOGGED = "SET_ISLOGGED";
